import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Code, Copy, LayoutTemplate, Settings, Eye } from 'lucide-react';
export function AdminEmbedBuilderPage() {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-1009">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-1010">
        <div className="flex items-center gap-4" data-id="element-1011">
          <span className="text-xl font-bold text-red-500" data-id="element-1012">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-1013"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-1014">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-1015">
              Dashboard
            </Link>
            <Link to="/admin/embed-builder" className="text-textMain" data-id="element-1016">
              Embed Builder
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full flex flex-col md:flex-row gap-8" data-id="element-1017">
        <div className="w-full md:w-1/3 shrink-0 space-y-6" data-id="element-1018">
          <div data-id="element-1019">
            <h1 className="text-2xl font-bold mb-1" data-id="element-1020">Embed Builder</h1>
            <p className="text-sm text-textMuted" data-id="element-1021">
              Generate iframe or JS snippets for public forms and widgets.
            </p>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6 space-y-6" data-id="element-1022">
            <div data-id="element-1023">
              <label className="block text-sm font-medium mb-2 flex items-center gap-2" data-id="element-1024">
                <LayoutTemplate className="w-4 h-4" data-id="element-1025" /> Widget Type
              </label>
              <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1026">
                <option data-id="element-1027">Booking Inquiry Form</option>
                <option data-id="element-1028">Public Artist Card</option>
                <option data-id="element-1029">Roster Grid</option>
                <option data-id="element-1030">Upcoming Shows Stream</option>
              </select>
            </div>

            <div data-id="element-1031">
              <label className="block text-sm font-medium mb-2 flex items-center gap-2" data-id="element-1032">
                <Settings className="w-4 h-4" data-id="element-1033" /> Styling Controls
              </label>
              <div className="space-y-3" data-id="element-1034">
                <div className="flex items-center justify-between" data-id="element-1035">
                  <span className="text-sm text-textMuted" data-id="element-1036">Theme</span>
                  <select className="px-3 py-1 bg-background border border-border rounded text-sm focus:outline-none" data-id="element-1037">
                    <option data-id="element-1038">Dark (Default)</option>
                    <option data-id="element-1039">Light</option>
                    <option data-id="element-1040">Transparent</option>
                  </select>
                </div>
                <div className="flex items-center justify-between" data-id="element-1041">
                  <span className="text-sm text-textMuted" data-id="element-1042">Primary Color</span>
                  <input type="color" defaultValue="#F59E0B" className="bg-transparent rounded cursor-pointer" data-id="element-1043" />
                </div>
                <div className="flex items-center justify-between" data-id="element-1044">
                  <span className="text-sm text-textMuted" data-id="element-1045">Hide Header</span>
                  <input type="checkbox" className="rounded border-border bg-background" data-id="element-1046" />
                </div>
              </div>
            </div>

            <div className="pt-4 border-t border-border" data-id="element-1047">
              <label className="block text-sm font-medium mb-2 flex items-center gap-2" data-id="element-1048">
                <Code className="w-4 h-4" data-id="element-1049" /> Embed Code
              </label>
              <div className="relative" data-id="element-1050">
                <textarea readOnly rows={4} className="w-full px-4 py-3 bg-background border border-border rounded-lg text-xs font-mono text-textMuted focus:outline-none resize-none" value={`<iframe src="https://booker.com/embed/form/the-empty-bottle?theme=dark&color=F59E0B" width="100%" height="600" frameborder="0" style="border-radius: 12px; border: 1px solid #27272A;"></iframe>`} data-id="element-1051" />
                <button onClick={handleCopy} className="absolute top-2 right-2 p-2 bg-surface border border-border rounded hover:bg-surfaceHover transition-colors" data-id="element-1052">
                  {copied ? <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-1053" /> : <Copy className="w-4 h-4 text-textMuted" data-id="element-1054" />}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 bg-surface border border-border rounded-xl p-6 flex flex-col" data-id="element-1055">
          <h3 className="font-semibold mb-4 flex items-center gap-2" data-id="element-1056">
            <Eye className="w-4 h-4" data-id="element-1057" /> Live Preview
          </h3>
          <div className="flex-1 bg-background border border-border rounded-lg border-dashed flex items-center justify-center p-8" data-id="element-1058">
            {/* Mock Form Preview */}
            <div className="w-full max-w-md bg-surface border border-border rounded-xl p-6" data-id="element-1059">
              <div className="text-center mb-6" data-id="element-1060">
                <h4 className="text-lg font-bold" data-id="element-1061">Booking Inquiry</h4>
                <p className="text-xs text-textMuted" data-id="element-1062">The Empty Bottle</p>
              </div>
              <div className="space-y-4" data-id="element-1063">
                <input disabled type="text" placeholder="Artist Name" className="w-full px-3 py-2 bg-background border border-border rounded text-sm opacity-50" data-id="element-1064" />
                <input disabled type="email" placeholder="Email" className="w-full px-3 py-2 bg-background border border-border rounded text-sm opacity-50" data-id="element-1065" />
                <input disabled type="text" placeholder="Requested Date" className="w-full px-3 py-2 bg-background border border-border rounded text-sm opacity-50" data-id="element-1066" />
                <button disabled className="w-full py-2 bg-primary text-background rounded font-medium text-sm opacity-50" data-id="element-1067">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}